const BluePencilSvg = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.75 15.75H9.74999M1.87497 16.125L6.03692 14.5242C6.30313 14.4219 6.43623 14.3707 6.56076 14.3038C6.67137 14.2444 6.77682 14.1759 6.876 14.099C6.98766 14.0123 7.0885 13.9115 7.29018 13.7098L15.75 5.25C16.5784 4.42157 16.5784 3.07843 15.75 2.25C14.9216 1.42157 13.5784 1.42157 12.75 2.25L4.29018 10.7098C4.0885 10.9115 3.98766 11.0123 3.90101 11.124C3.82405 11.2231 3.75552 11.3286 3.69615 11.4392C3.6293 11.5637 3.57811 11.6968 3.47572 11.9631L1.87497 16.125ZM1.87497 16.125L3.41856 12.1117C3.52902 11.8245 3.58425 11.6809 3.67897 11.6152C3.76176 11.5577 3.8642 11.5359 3.96319 11.5548C4.07647 11.5765 4.18526 11.6853 4.40283 11.9028L6.09715 13.5972C6.31472 13.8147 6.42351 13.9235 6.44514 14.0368C6.46405 14.1358 6.44231 14.2382 6.38483 14.321C6.31905 14.4157 6.17546 14.471 5.88827 14.5814L1.87497 16.125Z"
      stroke="#1369E9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BluePencilSvg;
